import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { useToast } from '../../../hooks/toast';

import getValidationErrors from '../../../utils/getValidationErrors';

import { useClinica } from '../../../hooks/clinica';
import SelectSync from '../../SelectSync';
import InputMoney from '../../InputMoney';
import {
  IValoresProcedimento,
  useProcedimento,
} from '../../../hooks/procedimentos';
import Input from '../../Input';
import { formatPrice } from '../../../utils/funcoes';

interface componentProps {
  ProCodigo: number;
  Adicionou(dados: IValoresProcedimento): void;
}
interface IFormDados {
  ConvCodigo: number;
  valor: number;
  ProRetorno: number;
}

const AddValor: React.FC<componentProps> = ({ ProCodigo, Adicionou }) => {
  const { addToast } = useToast();
  const { addValorConvenio } = useProcedimento();
  const { buscaConvenios, optionsConvenio } = useClinica();
  const [loading, setLoading] = useState(false);

  const formRefValor = useRef<FormHandles>(null);

  useEffect(() => {
    async function Busca(): Promise<void> {
      await buscaConvenios();
    }
    if (!optionsConvenio || optionsConvenio.length === 0) Busca();
  }, [buscaConvenios, optionsConvenio]);

  const handleSubmit = useCallback(
    async (dados: IFormDados) => {
      try {
        setLoading(true);
        formRefValor.current?.setErrors({});
        const schema = Yup.object().shape({
          ConvCodigo: Yup.string().required(),
          valor: Yup.number().required(),
          ProRetorno: Yup.number().required(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const dadosFormatados = {
          ...dados,
          ConvCodigo: Number(dados.ConvCodigo),
          ProCodigo,
        };

        const nomeConvenio =
          optionsConvenio.find(op => op.value === dados.ConvCodigo.toString())
            ?.label || '';

        console.log(addValorConvenio);

        await addValorConvenio(dadosFormatados, nomeConvenio);
        Adicionou({
          ...dados,
          ProCodigo,
          valorFormatado: formatPrice(dados.valor),
          convenio: nomeConvenio,
        });
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefValor.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao salvar valor',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, ProCodigo, addValorConvenio, optionsConvenio, Adicionou],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <div className="border p-2 rounded">
      <h6>Add valor</h6>
      <Form ref={formRefValor} onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <SelectSync
              name="ConvCodigo"
              label="Convênio"
              placeholder="Selecione"
              isClearable={false}
              handleSelectChange={handleOnChangeVazio}
              options={optionsConvenio}
            />
          </Col>
          <Col md={2}>
            <InputMoney name="valor" label="Valor" placeholder="valor" />
          </Col>
          <Col md={2}>
            <Input name="ProRetorno" label="Retorno" placeholder="Dias" />
          </Col>
          <Col md={2}>
            <Button
              type="submit"
              size="sm"
              variant="primary"
              disabled={loading}
              style={{ marginTop: '23px' }}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddValor;
